module.exports = __webpack_public_path__ + "img/status.85bdd8f2.svg";